export const installGtm = (trackingId: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });

    const { head } = document;
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${trackingId}`;
    head.insertBefore(script, head.firstChild);
};

export const pushToGTM = function (record: Record<string, unknown>) {
    window.dataLayer.push(record);
};
